export const imageURL = {
    url : 'https://api.adorntourism.com/Upload/'
}
